import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'process'

  }
];

@Component({
  selector: 'page-plan-process',
  templateUrl: './plan-process.html',
  styleUrls: ['./plan-process.scss']
})

export class PagePlanProcess implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any="";
  planProcess = [];
  //autoincreate
  filtered:any;
  ctrl:FormControl;
  items = [];
  lines=[];
  sorts = [
    { value: '1', viewValue: '1 (Start process)' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
    { value: '9', viewValue: '9' },
    { value: '10', viewValue: '10' }
  ];
sortingCtrl = new FormControl;
  //form
  form: FormGroup;
  selectedCtrl = new FormControl();
  lineCtrl = new FormControl();
  process = [];arr_process=[];
  selected:any;selected_:any;
  code:string;name:string;vender:string;ct:string;detail:string;id:string;
  ckedit:boolean=false;
  //upload
  fileupload:string;
  //data table
  data:any;
  rows = [];temp=[];
  //upload file
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  Name:string; tpr_id:string;
  myFile:File; /* property of File type */
  searchId:String;
  //dialog
  dialogRefWarning: MdDialogRef<WarningPlanProcessDialog>;
  dialogRef: MdDialogRef<processPlanDialog>;
  setId:any;
  sysPathPrint:String=environment.sysPath+"/api/process-group-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/process-group-list-export.php";
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.getSearchProcess();
    this.getLine();
    this.getStartData();

    //this.setId = this.intervalGetData();
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }

  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
        clearInterval(this.setId);
        }
      this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);

  }

  getStartData(){
    this.httpservice.fetchget('getJSON_plan_process.php?',(process) => {
      this.rows = process;
      this.temp = process;
      this.loadingIndicator = false;
      console.log('------this.machine------', this.key,process,this.rows);
    });
  }

  getLine(){
    this.httpservice.fetchget('getJSON_line_name.php?',(data) => {
      this.lines = data;
    });
  }

  getLineId(val:string,_event: any,index:any){

    if(_event.isUserInput){

        this.tpr_id = val;
        this.getProcess(val);
   

    console.log('line id',this.tpr_id);
  }
  }

  getProcess(val:string){
    this.httpservice.fetchget('getJSON_process_name.php?control=1&tpr_id='+val,(data)=>{
      this.process = data;
      console.log('process',data);
    });
  }



  getSearchProcess(){
    this.httpservice.fetchget('getJSON_plan_process_name.php?',(process) => {
      this.planProcess = process;
      console.log('------this.machine------', this.planProcess);
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.planProcess.filter((s) => new RegExp(val, 'gi').test(s.tb94f_name)) : this.planProcess;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deletePlanProcess.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.id = id;
    this.ckedit=true;


    this.httpservice.fetchget('getJSON_plan_process.php?id='+id,(process) => {


      this.httpservice.fetchget('getJSON_process_name.php?control=1&tpr_id='+process[0].tpr_id,(data)=>{
        this.process = data;
      });

      this.form.controls.name.setValue(process[0].tb94f_name);
      //this.user_selected.setValue("77");
      this.selected=process[0].process;
      console.log(process[0].process);
      //this.selected_=process[0].tb17_productionline_tpr_id;
      this.lineCtrl.setValue(process[0].tpr_id);
      this.sortingCtrl.setValue(process[0].tb94f_order);
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    this.ckedit = false;
    this.data = {
      id:this.id,
      name:this.form.controls.name.value,
      tpr_id:this.lineCtrl.value,
      process:this.selectedCtrl.value,
      sort:this.sortingCtrl.value
    }
    // insert data
    this.httpservice.fetchpost('editDataPlanProcess.php', this.data, (cb) => {});  
    this.getStartData();
    console.log('------edit ------');
    this.selectedCtrl.reset();
    this.lineCtrl.reset();
    this.form.reset();
    this.arr_process =[];
    this.sortingCtrl.reset();


  }

  cancelEdit(){
    this.ckedit = false;
    this.selectedCtrl.reset();
    this.lineCtrl.reset();
    this.form.reset();
    this.arr_process=[];
    this.sortingCtrl.reset();
  }

  getInfo(val:string,_event: any,index:any){

    if(_event.isUserInput){
    if(_event.source.selected==true){
      this.arr_process.push(val);
    }else{
      this.arr_process.splice(index, 1);
    }

    console.log('arr_process',_event);
  }
  }



save(){
  this.setId = this.intervalGetData();
  this.data = {
    name:this.form.controls.name.value,
    tpr_id:this.lineCtrl.value,
    process:this.arr_process,
    sort:this.sortingCtrl.value
  }
  // insert data
  this.httpservice.fetchpost('insertDataPlanProcess.php', this.data, (cb) => {});
  this.getStartData();
  this.form.reset();
  this.selectedCtrl.reset();
  this.lineCtrl.reset();
  this.arr_process = [];
  this.sortingCtrl.reset();
}
getSearchId(id:String){
  this.searchId = id;
}
search(){ 
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_plan_process.php?id='+this.searchId,(process) => {
    this.rows = process;
  });
  this.ctrl.reset();
  this.sortingCtrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])]
    });

  }

    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb94f_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tpr_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }


  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(processPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(processPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value){
          this.edit();
        }else{
          this.warningDialog('Please fill in Name , Line , Process!');
        }
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(processPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value){
          this.save();
        }else{
            this.warningDialog('Please fill in Name , Line , Process!');
        }
      
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningPlanProcessDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'plan-process-dialog',
  templateUrl: 'dialog.html',
})
export class processPlanDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<processPlanDialog>) {}
}

//warning
@Component({
  selector: 'warning-plan-process-dialog',
  templateUrl: 'warning.html',
})
export class WarningPlanProcessDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningPlanProcessDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/plan-process/plan-process.ts